// material ui icons
import SensorsOffIcon from '@mui/icons-material/SensorsOff';

// material ui
import { Card, CardContent, Divider, Typography } from '@mui/material';

// api
import { ReadAlarmDto } from '@/api/generated/recalc/endpoints/v1/alarms';

// relative
import AlarmTypeCardHeader from './AlarmTypeCardHeader';

const ExternalSensorDown = ({ alarm }: { alarm: ReadAlarmDto }) => {
  console.log('Rendering ExternalSensorDown with alarm:', alarm);
  return (
    <Card>
      <AlarmTypeCardHeader
        alarm={alarm}
        title="External Sensor Down"
        avatarIcon={<SensorsOffIcon />}
        showSubheader={false}
        showMetaDataDrawer={false}
      />
      <Divider />
      <CardContent>
        <Typography variant="body1">
          {alarm.Message || alarm.Details}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ExternalSensorDown;
